import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API } from '@lmc-app/core/constants/api.constant';

/**
 * Authentication Service
 *
 * Handles authentication-related HTTP requests.
 * Tokens are managed via Bearer header (Authorization interceptor reads from localStorage).
 */
@Injectable({
	providedIn: 'root',
})
export class AuthService {
	constructor(private readonly http: HttpClient) {}

	/**
	 * Login with credentials
	 * Returns accessToken and refreshToken in response body
	 */
	login(request: LoginRequest): Observable<any> {
		return this.http.post<any>(API.AUTH.LOGIN, request);
	}

	/**
	 * Refresh access token using refresh token from localStorage
	 * Sends refresh token in request body, returns new token pair
	 */
	refreshToken(refreshToken: string): Observable<RefreshTokenResponse> {
		return this.http.post<RefreshTokenResponse>(API.AUTH.REFRESH_TOKEN, { refreshToken });
	}
}